export const FormRegistrationPhoneNumberTranslationsUk = {
  phoneNumberLabel: 'Номер телефону',
  phoneNumberPlaceholder: '+380',
  passwordLabel: 'Пароль',
  passwordPlaceholder: '****',
  passwordErrorMessage: 'Будь ласка, введіть правильний пароль',
  privacyPolicyText: 'Натисканням на Зареєструватися ви приймаєте',
  privacyPolicyLinkText: 'Політику конфіденційності',
  registerButton: 'Зареєструватися',

  // error
  'Required field': 'Обов`язкове поле',
  'Invalid phone number format': 'Неправильний формат номера телефону',
  'Password must be at least 8 characters':
    'Пароль має бути не менше 8 символів',
  'Password must be less than 32 characters':
    'Пароль має бути менше 32 символів',
  'Password must contain at least 8 Latin characters, one uppercase letter, one digit':
    'Пароль повинен містити мінімум 8 латинських символів, одну велику літеру, одну цифру',

  // errors back-end
  'Phone number in use': 'Номер телефону використовується',
};
